import { tagsCloud } from "@/mocks/heiliao";

const cols = [
  { title: "版块", items: ["最新实锤", "话题墙", "吃瓜热度榜", "细节对比", "原帖存档", "甄别FAQ"] },
  { title: "关于", items: ["我们怎么做筛选", "投稿 / 提供线索", "素材归档规范", "意见与纠错", "联系方式"] },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300/60 bg-secondary-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div className="max-w-md">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
                黑
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">
                黑料<span className="ml-1 align-super text-[10px] font-bold tracking-widest text-primary-600">HEILIAO</span>
              </span>
            </a>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              不追风，只追证据。把实锤证据、截图石锤、录音视频与原帖存档按时间线摊开，细节对比也放上台面，让你看瓜看得明白。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {tagsCloud.map((t) => (
                <span
                  key={t}
                  className="whitespace-nowrap rounded-full border border-background-300/70 bg-background-50 px-2.5 py-1 text-xs text-foreground-600"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h3 className="mb-3 text-sm font-black text-foreground-950">{c.title}</h3>
              <ul className="space-y-2">
                {c.items.map((it) => (
                  <li key={it}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {it}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg border border-background-300/70 bg-background-50 px-4 py-3 text-xs leading-6 text-foreground-500">
          <span className="font-bold text-foreground-700">甄别提醒：</span>
          本页内容为吃瓜素材与口径的整理呈现，「实锤 / 存疑 / 辟谣」仅代表我们当前对可核验信源的判断，不构成对被报道对象事实行为的定性结论。
          请以官方与权威机构信息为准；对未经核实的单方说法，请勿进行人身攻击与传播，网络发言请保持理性与善意。
        </div>

        <div className="mt-6 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row">
          <span>© {new Date().getFullYear()} 黑料 HEILIAO · 本站仅作演示用途</span>
          <a href="#top" className="flex items-center gap-1 whitespace-nowrap rounded-full border border-foreground-300 px-3 py-1 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600">
            <i className="ri-arrow-up-line"></i>回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}